import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import * as CryptoJS from "crypto-js";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import swal from "sweetalert";
import { makeStyles } from "@material-ui/core/styles";
import "./styles.scss";
import FileUpload from "../FileUpload";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import { IconButton, Link } from "@material-ui/core";
import arrow from "../../../assets/images/arrow.png";
import { deleteGroupSession } from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
import { deleteSessionData } from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
import ModalVisible from "../../AdminModule/Dashboard/MentorDashboard/CohortGroupSession/Modal/modal";
// import ModeratorCopy from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import ModeratorCopy from "../../../assets/svg/dashboard/profile-iconRound.svg";
import * as momentzone from "moment-timezone";
import { PROFILE_KEY } from "../constants/actionConstants";
function SessionsModal(props) {
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }

    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };

    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const [showEditSession, setShowEditSession] = useState(false);
  const [allMentorlist, setAllMentorList] = useState();
  const [allStartupList, setAllStartupList] = useState();
  const { deleteSessionData, deleteGroupSession, fromModule } = props;

  const handleClose = () => {
    props.setModalVisibility(false);
    setScheduleModalOpen(false);
  };
  const handleEdit = () => {
    if (props.fromModule === "groupSessions") {
      setAllMentorList(props?.modalData?.mentorUserList);
      setAllStartupList(props?.modalData?.startUpUserList);

      setScheduleModalOpen(true);

      // props.setModalVisibility(false);
    } else {
      props.setModalOpen(true);
      props.openEditModal(true);
    }
  };
  const [tooltipData, setTooltipData] = useState(
    "Click to copy MAARG Session Link"
  );
  const [tooltipData2, setTooltipData2] = useState(
    "Click to Copy MAAARG session Link as a Moderator"
  );
  const [showEditCohort, setShowEditCohort] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [tooltip2, setTooltip2] = useState(false);
  const [toggleStartup, setToggleStartup] = useState(false);
  const [toggleMentor, setToggleMentor] = useState(false);
  const [toggleSpeaker, setToggleSpeaker] = useState(false);
  const [toogleModal, setToogleModal] = useState(false);
  // const [videoUrl, setVideoUrl] = useState();

  const handleView = (videourl, videoArray, cohortAdminId,title) => {
    // if (videoUrl) {
      props.setShowVideo(true);
      props.setSessionTitle(title);
      props.setModalVisibility(false);
      props.setVideoUrl(videourl);
      if(videoArray !== undefined && videoArray!== null && videoArray !== "" &&  videoArray?.length > 0)
      props.setVideoArr(videoArray);
    // }
  };
  const valueLogin = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  useEffect(() => {
    // const timezonea = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // alert(moment().format('zz'))
    // alert(moment.tz(props?.modalData?.sessionStart, timezonea).format('z'))

    if (tooltip) {
      setTimeout(() => {
        setTooltipData("Your MAARG Session Link is copied");
      }, 100);

      setTimeout(() => {
        setTooltipData("Click to copy MAARG Session Link");
        setTooltip(false);
      }, 6000);
    }
  }, [tooltip]);
  useEffect(() => {
    // const timezonea = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // alert(moment().format('zz'))
    // alert(moment.tz(props?.modalData?.sessionStart, timezonea).format('z'))

    if (tooltip2) {
      setTimeout(() => {
        setTooltipData2("Your MAARG Session Moderator Link is copied");
      }, 100);

      setTimeout(() => {
        setTooltipData2("Click to Copy MAAARG session Link as a Moderator");
        setTooltip2(false);
      }, 6000);
    }
  }, [tooltip2]);
  const handleDelete = () => {
    swal("Are you sure you want to delete your Session?", {
      icon: "warning",
      buttons: {
        delete: {
          text: "OK",
        },
        decline: {
          text: "CANCEL",
        },
      },
    }).then((value) => {
      switch (value) {
        case "delete":
          if (props?.fromModule && props?.fromModule == "groupSessions") {
            let params = {
              cohortGroupSessionId: props?.modalData?.cohortGroupSessionId,
            };

            deleteGroupSession(params);
          } else {
            let params = {
              scheduleId: props?.modalData?.scheduleId,
            };

            deleteSessionData(params);
          }
          setTimeout(() => {
            swal("Your Session has been deleted!", {
              icon: "success",
            });
            props.setModalVisibility(false);
            setScheduleModalOpen(false);
            props.refreshPage(true);
            // props?.parentData(true);
          }, 500);
          break;

        case "decline":
          break;
        default:
          swal("Delete operation cancelled");
      }
    });
    // swal({
    //   title: "Are you sure you want to delete your Session?",
    //   // text: "Once deleted, you will not be able to recover this imaginary file!",
    //   icon: "warning",
    //   buttons: true,
    //   confirmButtonColor: 'LightSeaGreen',
    //   cancelButtonColor: 'LightSeaGreen',

    //   // dangerMode: true,
    // })
    // .then((willDelete) => {
    //   if (willDelete) {
    //     let params={
    //       scheduleId:props?.modalData?.scheduleId
    //     }
    //     deleteSessionData(params);
    //     props.parentData(true);
    //     setTimeout(()=>{
    //       swal("Your Session has been deleted!", {
    //         icon: "success",
    //       });
    //       props.setModalVisibility(false);
    //     },500)
    //   } else {
    //   }
    // });
  };
  useEffect(() => {
    if (
      moment().format("DD-MM-YYYY hh:mm A") >
        moment(props?.modalData?.sessionStart).format("DD-MM-YYYY hh:mm A") &&
      moment().format("DD-MM-YYYY hh:mm A") ==
        moment(props?.modalData?.sessionStart).format("DD-MM-YYYY hh:mm A")
    ) {
      setShowEditSession(false);
    } else {
      setShowEditSession(true);
    }
  }, []);
  useEffect(() => {
    if (toogleModal) {
      props.setModalVisibility(false);
      setScheduleModalOpen(false);
      setToogleModal(false);
    }
  }, [toogleModal]);
  useEffect(() => {
    let testTime = moment
      .tz(
        props?.modalData?.sessionDate,
        Intl.DateTimeFormat().resolvedOptions().timeZone
      )
      .format("z")
      .includes("-")
      ? "GMT" +
        moment
          .tz(
            props?.modalData?.sessionDate,
            Intl.DateTimeFormat().resolvedOptions().timeZone
          )
          .format("z")
      : moment
          .tz(
            props?.modalData?.sessionDate,
            Intl.DateTimeFormat().resolvedOptions().timeZone
          )
          .format("z");
    if (
      moment().format("DD-MM-YYYY hh:mm A") >
      moment(props?.modalData?.sessionDate).format("DD-MM-YYYY hh:mm A")
    ) {
      // if(testToggleType)
      setShowEditCohort(true);
      // else
    } else {
      setShowEditCohort(false);
    }
  }, []);
  let sessionStartDate1 = moment(props?.modalData?.sessionStartDate).format(
    "DD-MM-YYYY HH:mm A"
  );
  let sessionStartDate = moment(props?.modalData?.sessionStartDate)
  let sessionEndDate1 = moment(sessionStartDate1, "DD-MM-YYYY HH:mm A")
    .add(props?.modalData?.sessionDuration, "hours")
    .format("DD-MM-YYYY HH:mm A");
  let sessionMonth = moment(sessionStartDate1, "DD-MM-YYYY").format("MM");
  let sessionYear = moment(sessionStartDate1, "DD-MM-YYYY").format("YYYY");
  let beforetime1Month = moment(sessionStartDate1, "DD-MM-YYYY").format(
    "DD-MM-YYYY"
  );
  let beforetime1 = moment(sessionStartDate).subtract(60, "minutes").format("DD-MM-YYYY HH:mm A");
  // let beforetime1 = moment(sessionStartDate1, "DD-MM-YYYY HH:mm A")
  //   .subtract(5, "minutes")
  //   .format("DD-MM-YYYY HH:mm A");
  let aftertime1 = moment(sessionEndDate1, "DD-MM-YYYY HH:mm A")
    .add(60, "minutes")
    .format("DD-MM-YYYY HH:mm A");
  let currentDateTime1 = moment().format("DD-MM-YYYY HH:mm A");

  const testVCOpen2 = () => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let sessionYear = moment(props?.modalData?.sessionStartDate).format("YYYY");
    let sessionMonth = moment(props?.modalData?.sessionStartDate).format("MM");
    let sessionTime = moment(props?.modalData?.sessionStartDate);
    let sessionDuration = props?.modalData?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionDate = moment(props?.modalData?.sessionStartDate).format(
      "DD-MM-YYYY"
    );
    let presentDate = moment().format("DD-MM-YYYY");

    let endTime = moment(sessionTime)
      .add(sessionDuration + 1, "hours")
      .format("DD-MM-YYYY HH:mm A");

    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      swal({
        title: "Meeting Not Started",
        text: `Cannot join meeting before scheduled time.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        swal({
          title: "Meeting Completed",
          text: `Cannot join a completed meeting.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
       }
       else   if(sessionDate === presentDate )
       {
        if(presentTime  >= beforetime1 && endTime >= presentTime)
        { 
          if(props?.modalData?.cohortAdminId == valueLogin?.id)
          window.open(props?.modalData?.vcUrl+'?jwt='+props?.modalData?.jwtToken, "_blank");
          else
          window.open(props?.modalData?.vcUrl, "_blank");
        } else if (presentTime < beforetime1) {
          swal({
            title: "Meeting Not Started",
            text: `Cannot join meeting before scheduled time.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        } else {
          swal({
            title: "Scheduled Time Over",
            text: `You cannot join meeting.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        }
      } else {
        swal({
          title: "Meeting Not Started",
          text: `Cannot join meeting before scheduled time.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      }
    } else if (sessionYear < currentYear) {
      swal({
        title: "Scheduled Time Over",
        text: `You cannot join meeting.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    }
  };

  const testVCOpen = () => {
    let sessionStartDate = moment(props?.modalData?.sessionStartDate).format(
      "DD-MM-YYYY HH:mm A"
    );
    let sessionEndDate = moment(sessionStartDate, "DD-MM-YYYY HH:mm A")
      .add(props?.modalData?.sessionDuration, "hours")
      .format("DD-MM-YYYY HH:mm A");
    let beforetime = moment(sessionStartDate, "DD-MM-YYYY HH:mm A")
      .subtract(10, "minutes")
      .format("DD-MM-YYYY HH:mm A");
    let aftertime = moment(sessionEndDate, "DD-MM-YYYY HH:mm A")
      .add(60, "minutes")
      .format("DD-MM-YYYY HH:mm A");
    let currentDateTime = moment().format("DD-MM-YYYY HH:mm A");

    // let sessionTime = moment(props?.modalData?.sessionStart).format(
    //   "DD-MM-YYYY hh:mm A"
    // );
    // let sessionTimeEnd = moment(props?.modalData?.sessionEnd).format(
    //   "DD-MM-YYYY hh:mm A"
    // );

    // let aftertime = moment(sessionTimeEnd, "DD-MM-YYYY hh:mm A")
    //   .add(60, "minutes")
    //   .format("DD-MM-YYYY hh:mm A");
    // let aftertimetest = moment(sessionTimeEnd, "DD-MM-YYYY hh:mm A")
    //   .subtract(15, "minutes")
    //   .format("DD-MM-YYYY hh:mm A");
    // let beforetime = moment(sessionTime, "DD-MM-YYYY hh:mm A")
    //   .subtract(10, "minutes")
    //   .format("DD-MM-YYYY hh:mm A");

    // let completedDateTime =
    //   // props?.modalData?.sessionDuration === 0.5
    //   //   ? moment(sessionTime, "DD-MM-YYYY hh:mm A")
    //   //       .add(90, "minutes")
    //   //       .format("DD-MM-YYYY hh:mm A")
    //   //   :
    //   moment(sessionTimeEnd, "DD-MM-YYYY hh:mm A")
    //     .add(props?.modalData?.sessionDuration + 1, "hours")
    //     .format("DD-MM-YYYY hh:mm A");

    // let currentDateTime = moment().format("DD-MM-YYYY hh:mm A");
    if (currentDateTime < beforetime) {
      swal({
        title: "Meeting Not Started",
        text: `Cannot join meeting before scheduled time.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    } else if (currentDateTime > aftertime) {
      if (props?.modalData?.sessionStatus === "SCHEDULED") {
        swal({
          title: "Scheduled Time Over",
          text: `You cannot join meeting.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      } else {
        swal({
          title: "Meeting Completed",
          text: `Cannot join a completed meeting.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      }
      // window.open(props?.modalData?.vcUrl, "_blank");
    } else {
      if(props?.modalData?.cohortAdminId == valueLogin?.id)
      window.open(props?.modalData?.vcUrl+'?jwt='+props?.modalData?.jwtToken, "_blank");
      else
      window.open(props?.modalData?.vcUrl, "_blank");
    }

    // swal(
    //   "Complete Existing Session",
    //   "You Cannot Complete Session Before Scheduled Meet Time",
    //   "info"
    // );
    //false
  };

  // if (
  //   moment().format("DD-MM-YYYY hh:mm A") >
  //     moment(props?.modalData?.sessionStart).format("DD-MM-YYYY hh:mm A") ||
  //   moment().format("DD-MM-YYYY hh:mm A") ==
  //     moment(props?.modalData?.sessionStart).format("DD-MM-YYYY hh:mm A")
  // ) {
  // } else {
  //   swal("Can't open the meeting link before scheduled time", {
  //     icon: "error",
  //   })
  // }
  const recordingData = [
    {
      id: 1,
      url: props?.modalData?.recording,
    },
    {
      id: 2,
      url: props?.modalData?.recording,
    },
    {
      id: 3,
      url: props?.modalData?.recording,
    },
    {
      id: 4,
      url: props?.modalData?.recording,
    },
  ];

  const testEditStatus = (item) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let ternaryValue= item?.sessionStartDate !== undefined && item?.sessionStartDate !== null && item?.sessionStartDate !== "" ? item?.sessionStartDate  :  item?.sessionStart
    let sessionYear = moment(ternaryValue).format("YYYY");
    let sessionMonth = moment(ternaryValue).format("MM");
    let sessionTime = moment(ternaryValue);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionStartTime1 = moment(sessionTime);
    let sessionDate = moment(ternaryValue).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let beforetime1 = moment(sessionStartTime1).subtract(60, "minutes").format("DD-MM-YYYY HH:mm A");
    let endTime = moment(sessionTime)
    .add(sessionDuration + 1, "hours")
    .format("DD-MM-YYYY HH:mm A");
    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      swal({
        title: "Meeting Not Started",
        text: `Cannot join meeting before scheduled time.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        swal({
          title: "Meeting Completed",
          text: `Cannot join a completed meeting.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      } else if (sessionDate === presentDate) {
        if (presentTime >= beforetime1 && endTime >= presentTime) {
          window.open(item?.vcUrl + "?jwt=" + item?.jwtToken, "_blank");
        } else if (presentTime < beforetime1) {
          swal({
            title: "Meeting Not Started",
            text: `Cannot join meeting before scheduled time.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        } else {
          swal({
            title: "Scheduled Time Over",
            text: `You cannot join meeting.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        }
      } else {
        swal({
          title: "Meeting Not Started",
          text: `Cannot join meeting before scheduled time.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      }
    } else if (sessionYear < currentYear) {
      swal({
        title: "Scheduled Time Over",
        text: `You cannot join meeting.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    }
  };
  const testButtonsRow = (item) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let ternaryValue= item?.sessionStartDate !== undefined && item?.sessionStartDate !== null && item?.sessionStartDate !== "" ? item?.sessionStartDate  :  item?.sessionStart
    let sessionYear = moment(ternaryValue).format("YYYY");
    let sessionMonth = moment(ternaryValue).format("MM");
    let sessionTime = moment(ternaryValue);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionStartTime1 = moment(sessionTime);
    let sessionDate = moment(ternaryValue).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let beforetime1 = moment(sessionStartTime1).subtract(60, "minutes").format("DD-MM-YYYY HH:mm A");
    let endTime = moment(sessionTime)
    .add(sessionDuration + 1, "hours")
    .format("DD-MM-YYYY HH:mm A");
    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
     return false
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        return false

      } else if (sessionDate === presentDate) {
       if (presentTime < beforetime1) {
          return true
        } else {
          return false
        }
      } 
      else if ( sessionDate  > presentDate) {
        return true

      }
    } 
    
    else if(sessionMonth > currentMonth) {
      return true
    }
    else if(currentMonth  > sessionMonth) {
      return false
    }
    else if (sessionYear < currentYear) {
      return false
    }
  };
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(
    //   CryptoJS.enc.Hex
    // );

    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);

    // let aesText = iv + "::" + salt + "::" + ciphertext;

    return btoa(text);
  };
  const ViewProfile = (item, id) => {
    // setSelectedRow(id);
    let reRoute = window.open(
      `/mentor-profile/${encryptAES2(item, PROFILE_KEY)}`,
      "_blank"
    );
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const redirectProfile = (item, id) => {
  
    // sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
    let reRoute = window.open(`/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => {
            props.setModalVisibility(false);
            setScheduleModalOpen(false);
          }}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
          className="sessiondeatilsnewagainanother1st"
        >
          <Modal.Header
            className="d-flex "
            style={{ justifyContent: "space-between" }}
          >
            <Modal.Title className="modalHeading">
              {props?.fromModule &&
              (props?.fromModule === "groupSessions" ||
                props?.fromModule === "createSessions")
                ? "COHORT SESSION DETAILS"
                : "SESSION DETAILS"}
            </Modal.Title>
            <div className="newuserTooltip">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              />
              <span
                className="tooltiptext  close-window"
                style={{ left: "-130px", top: "2px", width: "130px" }}
              >
                Close Window
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            {scheduleModalOpen && (
              <ModalVisible
                refreshPage={props.refreshPage}
                clickModaldata={props.clickModaldata}
                newCohortid={props.newCohortid}
                modalOpen={scheduleModalOpen}
                allMentorList={
                  props?.fromModule === "groupSessions"
                    ? props?.modalData?.mentorUserList
                    : props.allMentorList
                }
                allStartupList={
                  props?.fromModule === "groupSessions"
                    ? props?.modalData?.startUpUserList
                    : props.allStartupList
                }
                // mentorshipId={params.mentorshipId}
                setModalOpen={setScheduleModalOpen}
                onBroadcastSelectionChange={props.onBroadcastSelectionChange}
                setTaggingList={props.setTaggingList}
                taggingList={props.taggingList}
                fromPage="Calendar"
                hideModal={setToogleModal}
                parentData={setToogleModal}
                editData={
                  props?.fromModule === "groupSessions" ||
                  props?.fromModule === "createSessions"
                    ? props.modalData
                    : undefined
                }
              />
            )}

            <div className="session-detailsModal">
              <div className="col-md-10 session-detailwhole">
                {props?.modalData?.sessionStatus === "CANCELLED" && (
                  <div
                    className="d-flex justify-content-end fixedMessageSticky"
                    style={{
                      position: "relative",
                      marginTop: "0rem",
                    }}
                  >
                    <div
                      className="fixedMessageStickyText2"
                      style={{
                        right: "-0.7rem",
                        paddingLeft: "10px",
                        borderRadius: "6px 0px 0px 6px",
                      }}
                    >
                      This session is cancelled
                    </div>
                  </div>
                )}
                <table
                  id="session"
                  // className="SessioncohortDetails-mom"
                >
                  <tbody>
                    {props?.fromModule &&
                    (props?.fromModule === "groupSessions" ||
                      props?.fromModule === "createSessions") ? (
                      <tr>
                        <td className="session-question">
                          <p>COHORT NAME</p>
                        </td>
                        <td className="session-answer">
                          <p>
                            {props?.modalData?.cohortApplication?.program_name}
                          </p>
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {props.fromModule &&
                    props.fromModule === "groupSessions" ? (
                      <tr>
                        <td className="session-question">
                          <p>SESSION TITLE</p>
                        </td>
                        <td className="session-answer">
                          <p>{props?.modalData?.sessionTitle}</p>
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}

                    <tr>
                      <td className="session-question">
                        <p>START DATE</p>
                      </td>

                      <td className="session-answer purposedatafont">
                        <p>
                          {moment(props?.modalData?.sessionDate).format(
                            "DD-MM-YYYY"
                          )}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="session-question">
                        <p>START TIME</p>
                      </td>
                      <td className="session-answer purposedatafont">
                        <p>
                          {/* {moment(props?.modalData?.sessionStart).format(
                            "hh:mm a"
                          )} */}
                          {/* {
                            props?.modalData?.sessionTime
                          } */}
                          {/* {alert(    moment(props?.modalData?.sessionStartDate).format(
                          "hh:mm a"))} */}
                          {props?.fromModule === "groupSessions" ? (
                            <div>
                              {moment(
                                props?.modalData?.sessionStartDate
                              ).format("hh:mm a")}
                              (
                              {moment
                                .tz(
                                  props?.modalData?.sessionStartDate,
                                  Intl.DateTimeFormat().resolvedOptions()
                                    .timeZone
                                )
                                .format("z")
                                .includes("-")
                                ? "GMT" +
                                  moment
                                    .tz(
                                      props?.modalData?.sessionStartDate,
                                      Intl.DateTimeFormat().resolvedOptions()
                                        .timeZone
                                    )
                                    .format("z")
                                : moment
                                    .tz(
                                      props?.modalData?.sessionStartDate,
                                      Intl.DateTimeFormat().resolvedOptions()
                                        .timeZone
                                    )
                                    .format("z")}
                              )
                            </div>
                          ) : (
                            <div>
                              {moment(props?.modalData?.sessionStart).format(
                                "hh:mm a "
                              )}{" "}
                              (
                              {moment
                                .tz(
                                  props?.modalData?.sessionStart,
                                  Intl.DateTimeFormat().resolvedOptions()
                                    .timeZone
                                )
                                .format("z")
                                .includes("-")
                                ? "GMT" +
                                  moment
                                    .tz(
                                      props?.modalData?.sessionStart,
                                      Intl.DateTimeFormat().resolvedOptions()
                                        .timeZone
                                    )
                                    .format("z")
                                : moment
                                    .tz(
                                      props?.modalData?.sessionStart,
                                      Intl.DateTimeFormat().resolvedOptions()
                                        .timeZone
                                    )
                                    .format("z")}
                              )
                            </div>
                          )}
                          {/* {moment.tz([2012, 0], 'America/New_York').format('z')} */}
                          {/* {moment(props?.modalData?.sessionStart, 'hh:mm a').format(
                            "hh:mm A"
                          )} */}
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td className="session-question">
                        <p>SESSION DURATION</p>
                      </td>
                      <td className="session-answer purposedatafont">
                        <p>{props?.modalData?.sessionDuration} hours</p>
                      </td>
                    </tr>
                    <tr>
                      <td className="session-question">
                        <p>SESSION FORMAT</p>
                      </td>
                      <td className="session-answer purposedatafont">
                        {props?.modalData?.sessionFormat === "ONLINE" ? (
                          <p>{"ON MAARG PLATFORM"}</p>
                        ) : (
                          props?.modalData?.sessionFormat
                        )}
                      </td>
                    </tr>
                    {/* <tr>
                        <td className="session-question">
                          <p>RECORDING PLAYBACK</p>
                        </td>
                        <td>

                        </td>
                        </tr> */}
                    {props?.modalData?.recording &&
                      props?.modalData?.recording != null && (
                        <tr className="col-12">
                          <td
                            className="session-question col-md-6 col-sm-6 col-11"
                            style={{
                              alignItems: "start",
                              display: "flex",
                              width: "100%",
                              border: "none",
                            }}
                          >
                            <p>RECORDING PLAYBACK</p>
                          </td>
                          <td className="session-answer col-md-6 col-sm-6 col-1">
                            {/* {recordingData?.map((item, index) => (
                              <p className="newuserTooltip">
                                <span
                                  style={{
                                    fontWeight: 700,
                                    color: "#3AC2D7",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleView(item?.url)}
                                >
                                  {`View Recording ${index + 1}`}
                                </span>

                                <span
                                  className="tooltiptext   tooltip-bottom"
                                  style={{
                                    left: "20px",
                                    top: "30px",
                                    width: "150px",
                                    padding: "0px 0px 5px",
                                  }}
                                >
                                  {`Play Recording ${index + 1}`}
                                </span>
                              </p>
                            ))} */}

                            <p className="newuserTooltip">
                              <span
                                style={{
                                  fontWeight: 700,
                                  color: "#3AC2D7",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleView(props?.modalData?.recording,props?.modalData?.recordings,props?.modalData?.cohortAdminId ,props?.modalData?.sessionTitle );
                                }}
                              >
                                {`View Recording`}
                              </span>

                              <span
                                className="tooltiptext   tooltip-bottom"
                                style={{
                                  left: "20px",
                                  top: "30px",
                                  width: "150px",
                                  padding: "0px 0px 5px",
                                }}
                              >
                                {/* Play Recording */}
                                {`Play Recording`}
                              </span>
                              {/* {modalValue?.sessionHours} */}
                            </p>
                            {/* <p className="newuserTooltip">
                              <span
                                style={{
                                  fontWeight: 700,
                                  color: "#3AC2D7",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleView(props?.modalData?.recording)
                                }
                              >
                                View
                              </span>
                            
                              <span
                                className="tooltiptext   tooltip-bottom"
                                style={{
                                  left: "20px",
                                  top: "30px",
                                  width: "150px",
                                  padding: "0px 0px 5px",
                                }}
                              >
                                Play Recording
                              </span>
                            </p> */}
                          </td>
                        </tr>
                      )}
                    {
                    props?.modalData?.sessionStatus === "COMPLETED" ||
                    props?.modalData?.sessionStatus == "CANCELLED" ||
                     props?.modalData?.sessionStatus == "AUTOCOMPLETED" ||
                     props?.modalData?.sessionStatus == "CLOSED"
                      ? ""
                      :   props?.modalData?.sessionFormat == "ONLINE"  && (
                          <tr>
                            <td className="session-question">
                              <p>VC LINK</p>
                            </td>
                            <td className="session-answer purposedatafont">
                              <div className="d-flex justify-content-between">
                                <div>
                                  {props?.modalData?.sessionFormat ===
                                    "ONLINE" && props?.modalData?.vcUrl ? (
                                    props?.modalData?.sessionStatus ===
                                    "COMPLETED" ? (
                                      props?.modalData?.vcUrl
                                    ) : (
                                      <div className="newuserTooltip">
                                        <Link
                                          style={{
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                          }}
                                          onClick={
                                            () => testVCOpen2()
                                            // window.open(
                                            //   props?.modalData?.vcUrl,
                                            //   "_blank"
                                            // )
                                          }
                                        >
                                          Click to Join MAARG Session
                                        </Link>
                                        <span className="tooltiptext tooltip-bottom sessionsModalTooltip">
                                          All chats and video discussions may be
                                          recorded for quality purposes
                                        </span>
                                      </div>
                                    )
                                  ) : (
                                    "NA"
                                  )}
                                </div>

                                {props?.modalData?.sessionFormat === "ONLINE" &&
                                props?.modalData?.vcUrl
                                  ? props?.modalData?.sessionStatus ===
                                    "COMPLETED"
                                    ? ""
                                    : currentDateTime1 > aftertime1 &&
                                      props?.modalData?.sessionStatus ===
                                        "SCHEDULED"
                                    ? ""
                                    : props?.modalData?.sessionFormat !==
                                        "OFFLINE" &&
                                      props?.modalData?.sessionFormat !==
                                        "OTHER" && (
                                        <>
                                        <div>
                                          <IconButton
                                            onClick={() =>
                                              // navigator.clipboard.writeText(
                                              //   `Meeting at ${moment(
                                              //     props?.modalData?.sessionDate
                                              //   ).format(
                                              //     "DD-MM-YYYY"
                                              //   )}\n  Duration (Hours): ${
                                              //     props?.modalData?.sessionDuration
                                              //   }
                                              //   Goals:${props?.modalData?.sessionGoals?.map(
                                              //     (goal, index) => `${goal}\n`
                                              //   )}
                                              //   Join MAARG Meeting: <a href="${props?.modalData?.vcUrl}"  target="_blank">
                                              //    Click Here to join MAARG Meeting
                                              //   <a/>
                                              //  `
                                              // )
                                              navigator.clipboard.writeText(
                                                `You are Invited to a scheduled MAARG meeting:\n\nTopic : MAARG Meeting \nTime : ${moment(
                                                  props?.modalData
                                                    ?.sessionStartDate
                                                ).format(
                                                  "MMM. D, YYYY"
                                                )} ${moment(
                                                  props?.modalData
                                                    ?.sessionStartDate
                                                ).format("hh:mm a")} (${
                                                  moment
                                                    .tz(
                                                      props?.modalData
                                                        ?.sessionStartDate,
                                                      Intl.DateTimeFormat().resolvedOptions()
                                                        .timeZone
                                                    )
                                                    .format("z")
                                                    .includes("-")
                                                    ? "GMT" +
                                                      moment
                                                        .tz(
                                                          props?.modalData
                                                            ?.sessionStartDate,
                                                          Intl.DateTimeFormat().resolvedOptions()
                                                            .timeZone
                                                        )
                                                        .format("z")
                                                    : moment
                                                        .tz(
                                                          props?.modalData
                                                            ?.sessionStartDate,
                                                          Intl.DateTimeFormat().resolvedOptions()
                                                            .timeZone
                                                        )
                                                        .format("z")
                                                })
                                                  \nDuration (Hours): ${
                                                    props?.modalData
                                                      ?.sessionDuration
                                                  }\n\nGoals:${props?.modalData?.sessionGoals?.map(
                                                  (goal, index) =>
                                                    `\n${index + 1}. ${goal}`
                                                )}\n\nJoin MAARG Meeting:\n${
                                                  props?.modalData?.vcUrl
                                                }`
                                              )
                                            }
                                          >
                                            <div className="newuserTooltip">
                                              <ContentCopyIcon
                                                onClick={() => {
                                                  setTooltip(true);
                                                }}
                                              />

                                              <span
                                                className="tooltiptext tooltip-bottom "
                                                style={
                                                  !tooltip
                                                    ? {
                                                        top: "3.5rem",
                                                        left: "-2.6rem",
                                                        width: "280px",
                                                        fontSize: "13px",
                                                      }
                                                    : {
                                                        top: "3.5rem",
                                                        left: "-2.6rem",
                                                        width: "280px",
                                                        backgroundColor:
                                                          "#b899cf",
                                                        fontSize: "13px",
                                                      }
                                                }
                                              >
                                                {tooltipData}
                                              </span>
                                            </div>
                                          </IconButton>
                                         
                                          {
                                            (props?.modalData?.cohortAdminId == valueLogin?.id || 
                                            valueLogin?.role == "Admin")
                                            &&
                                            <IconButton
                                            onClick={() =>
                                              navigator.clipboard.writeText(
                                                `You are Invited to a scheduled MAARG meeting:\n\nTopic : MAARG Meeting \nTime : ${moment(
                                                  props?.modalData
                                                    ?.sessionStartDate
                                                ).format(
                                                  "MMM. D, YYYY"
                                                )} ${moment(
                                                  props?.modalData
                                                    ?.sessionStartDate
                                                ).format("hh:mm a")} (${
                                                  moment
                                                    .tz(
                                                      props?.modalData
                                                        ?.sessionStartDate,
                                                      Intl.DateTimeFormat().resolvedOptions()
                                                        .timeZone
                                                    )
                                                    .format("z")
                                                    .includes("-")
                                                    ? "GMT" +
                                                      moment
                                                        .tz(
                                                          props?.modalData
                                                            ?.sessionStartDate,
                                                          Intl.DateTimeFormat().resolvedOptions()
                                                            .timeZone
                                                        )
                                                        .format("z")
                                                    : moment
                                                        .tz(
                                                          props?.modalData
                                                            ?.sessionStartDate,
                                                          Intl.DateTimeFormat().resolvedOptions()
                                                            .timeZone
                                                        )
                                                        .format("z")
                                                })
                                                  \nDuration (Hours): ${
                                                    props?.modalData
                                                      ?.sessionDuration
                                                  }\n\nGoals:${props?.modalData?.sessionGoals?.map(
                                                  (goal, index) =>
                                                    `\n${index + 1}. ${goal}`
                                                )}\n\nJoin MAARG Meeting:\n${
                                                  props?.modalData?.vcUrl+'?jwt='+props?.modalData?.jwtToken
                                                }`
                                              )
                                            }
                                          >
                                            <div className="newuserTooltip">
                                            <img src={ModeratorCopy} height={30} width={30} />

                                              <span
                                                className="tooltiptext tooltip-bottom "
                                                style={
                                                  !tooltip
                                                    ? {
                                                        top: "3.5rem",
                                                        left: "-7.5rem",
                                                        width: "400px",
                                                        fontSize: "13px",
                                                      }
                                                    : {
                                                        top: "3.5rem",
                                                        left: "-7.5rem",
                                                        width: "400px",
                                                        backgroundColor:
                                                          "#b899cf",
                                                        fontSize: "13px",
                                                      }
                                                }
                                              >
                                                {tooltipData2}
                                              </span>
                                            </div>
                                          </IconButton>
                                          }
                                      
                                          </div>
                                        </>
                                      )
                                  : ""}
                              </div>
                            </td>
                          </tr>
                        )}

{props?.modalData?.sessionFormat === "ONLINE" && props?.modalData?.venue !== null && props?.modalData?.venue !== "" &&  (
                          <tr>
                            <td className="session-question">
                              <p>VENUE</p>
                            </td>
                            <td className="session-answer purposedatafont">
                              <div className="d-flex justify-content-between">
                                <div>
                               {props?.modalData?.venue}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
{props?.modalData?.address !== null && props?.modalData?.address !== "" &&  (
                          <tr>
                            <td className="session-question">
                              <p>ADDRESS</p>
                            </td>
                            <td className="session-answer purposedatafont">
                              <div className="d-flex justify-content-between">
                                <div>
                               {props?.modalData?.address}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                        {props?.modalData?.phoneNo !== null && props?.modalData?.phoneNo !== "" &&  (
                          <tr>
                            <td className="session-question">
                              <p>CONTACT NUMBER</p>
                            </td>
                            <td className="session-answer purposedatafont">
                              <div className="d-flex justify-content-between">
                                <div>
                               {"+"}{props?.modalData?.phoneNo}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                        { props?.modalData?.directions !== null && props?.modalData?.directions !== "" &&  (
                          <tr>
                            <td className="session-question">
                              <p>DIRECTIONS LINK</p>
                            </td>
                            <td className="session-answer purposedatafont" >
                              <div className="d-flex justify-content-between">
                             
                                <div className="newuserTooltip">
                                        <Link
                                          style={{
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                          }}
                                          onClick={()=>window.open(
                                              props?.modalData?.directions,
                                              "_blank"
                                            )
                                          }
                                        >
                                          Click to view directions to the venue.
                                        </Link>
                                        <span className="tooltiptext tooltip-bottom sessionsModalTooltip">
                                          Click to view directions to the venue.
                                        </span>
                                      </div>
                              </div>
                            </td>
                          </tr>
                        )}
                    {props?.modalData?.sessionGoals?.map((goal, index) => {
                      return (
                        <tr style={{ borderBottom: "1px solid lightgray" }}>
                          <td className="session-question">
                            <p>SESSION GOALS - {index + 1}</p>
                          </td>
                          <td className="togglediv">
                            {goal.length > 53 ? (
                              <>
                                <div
                                  className="d-flex"
                                  style={{
                                    whiteSpace: "nowrap",
                                    flexDirection: "row",
                                  }}
                                >
                                  <div className="goalText">
                                    {goal.slice(0, 53)}
                                  </div>
                                  <div
                                    className="tooltipicon"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <b>...</b>
                                    <span
                                      className="tooltiptext7"
                                      style={{ top: "-115px", left: "98px" }}
                                    >
                                      <h5 style={{ color: "#fff" }}>
                                        SESSION GOALS - {index + 1}
                                      </h5>
                                      {goal}
                                    </span>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div className="goalText">{goal}</div>
                            )}
                          </td>
                          <td className="togglediv2 textdatatooltip">
                            {goal.length > 30 ? (
                              <>
                                <div
                                  className="d-flex"
                                  style={{
                                    whiteSpace: "nowrap",
                                    flexDirection: "row",
                                  }}
                                >
                                  <div className="goalText">
                                    {goal.slice(0, 10)}
                                  </div>
                                  <div
                                    className="tooltipicon"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <b>...</b>
                                    <span
                                      className="tooltiptext7"
                                      style={{
                                        height: "auto",
                                        left: "551px",
                                        width: "340px",
                                        fontSize: "13px",
                                        top: "-172px",
                                      }}
                                    >
                                      <h5 style={{ color: "#fff" }}>
                                        SESSION GOALS - {index + 1}
                                      </h5>
                                      {goal}
                                    </span>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div className="goalText">{goal}</div>
                            )}
                          </td>
                        </tr>
                      );
                    })}

                    <tr>
                      <td className="session-question">
                        <p>DESCRIPTION/REMARKS</p>
                      </td>
                      <td className="session-answer togglediv">
                        <p>
                          {props?.modalData?.desiredOutcomes === null ? (
                            "NA"
                          ) : props?.modalData?.desiredOutcomes.length > 53 ? (
                            <>
                              <div
                                className="d-flex"
                                style={{
                                  whiteSpace: "nowrap",
                                  flexDirection: "row",
                                }}
                              >
                                <div className="goalText">
                                  {props?.modalData?.desiredOutcomes.slice(
                                    0,
                                    53
                                  )}
                                </div>
                                <div
                                  className="tooltipicon"
                                  style={{ cursor: "pointer" }}
                                >
                                  <b>...</b>
                                  <span
                                    className="tooltiptext7"
                                    style={{ top: "-115px", left: "98px" }}
                                  >
                                    <h5 style={{ color: "#fff" }}>
                                      DESCRIPTION/REMARKS
                                    </h5>
                                    {props?.modalData?.desiredOutcomes}
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="goalText">
                              {props?.modalData?.desiredOutcomes}
                            </div>
                          )}
                        </p>
                      </td>
                      <td className="session-answer togglediv2 textdatatooltip">
                        <p>
                          {props?.modalData?.desiredOutcomes === null ? (
                            "NA"
                          ) : props?.modalData?.desiredOutcomes.length > 30 ? (
                            <>
                              <div
                                className="d-flex"
                                style={{
                                  whiteSpace: "nowrap",
                                  flexDirection: "row",
                                }}
                              >
                                <div className="goalText">
                                  {props?.modalData?.desiredOutcomes.slice(
                                    0,
                                    10
                                  )}
                                </div>
                                <div
                                  className="tooltipicon"
                                  style={{ cursor: "pointer" }}
                                >
                                  <b>...</b>
                                  <span
                                    className="tooltiptext7"
                                    style={{
                                      height: "auto",
                                      left: "551px",
                                      width: "340px",
                                      fontSize: "13px",
                                      top: "-172px",
                                    }}
                                  >
                                    <h5 style={{ color: "#fff" }}>
                                      DESCRIPTION/REMARKS
                                    </h5>
                                    {props?.modalData?.desiredOutcomes}
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="goalText">
                              {props?.modalData?.desiredOutcomes}
                            </div>
                          )}
                        </p>
                      </td>
                    </tr>
                    {props?.fromModule &&
                    (props?.fromModule === "groupSessions" ||
                      props?.fromModule === "createSessions") ? (
                      <>
                        <tr>
                          <td className="session-question">
                            <p>SESSION SPEAKER</p>
                          </td>
                          {props?.modalData?.speakerUserList &&
                          props?.modalData?.speakerUserList?.length > 2 &&
                          !toggleSpeaker ? (
                            <div className="d-flex flex-column">
                              {props?.modalData?.speakerUserList.map(function (
                                key,
                                index
                              ) {
                                if (index < 2)
                                  return (
                                    <>
                                      <td
                                        className="session-answer answersession2"
                                        // style={{ minWidth: "33rem" }}
                                      >
                                        
                                        <p className="sessionListMentor newuserTooltip"    onClick={() => {
                                  ViewProfile(
                                    key?.id,
                                    key?.applicant_name
                                  );
                                }}>{key.applicant_name}
                                  <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    // top: "35px",
                                    width: "150px",
                                    position: "absolute",
                                    left: "50px",
                                    paddingBottom:"10px"
                                  }}
                                >
                                  View Mentor Profile
                                </span></p>
                                      </td>
                                      {props?.modalData?.speakerUserList
                                        ?.length > 1 && index == 1 ? (
                                        <td
                                          className="session-answer answersession2"
                                          // style={{ minWidth: "33rem" }}
                                        >
                                          <div
                                            className="d-flex"
                                            onClick={() =>
                                              setToggleSpeaker(true)
                                            }
                                          >
                                            <div
                                              className="color-green21"
                                              style={{
                                                position: "relative",
                                                left: "-0.35rem",
                                                top: "-0.1rem",
                                              }}
                                            >
                                              View More
                                            </div>
                                            <div
                                              style={{
                                                cursor: "pointer",
                                                bottom: "0.5rem",
                                                right: "1.25rem",
                                              }}
                                              className="arrowCollapse"
                                            >
                                              <img
                                                style={{ width: "70%" }}
                                                src={arrow}
                                              />
                                            </div>
                                          </div>
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  );
                              })}
                            </div>
                          ) : (
                            props?.modalData?.speakerUserList.map(function (
                              key,
                              index
                            ) {
                              return (
                                <>
                                  <div className="d-flex flex-column">
                                    <td
                                      className="session-answer answersession2"
                                      // style={{ minWidth: "33rem" }}
                                    >
                                      <p className="sessionListMentor newuserTooltip"    onClick={() => {
                                  ViewProfile(
                                    key?.id,
                                    key?.applicant_name
                                  );
                                }}>{key.applicant_name}
                                      <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    // top: "35px",
                                    width: "150px",
                                    position: "absolute",
                                    left: "50px",
                                    paddingBottom:"10px"
                                  }}
                                >
                                  View Mentor Profile
                                </span></p>
                                    </td>
                                    {index ===
                                      props?.modalData?.speakerUserList
                                        ?.length -
                                        1 &&
                                    props?.modalData?.speakerUserList?.length >
                                      2 ? (
                                      <td
                                        className="session-answer answersession2"
                                        // style={{ minWidth: "33rem" }}
                                      >
                                        <div
                                          className="d-flex"
                                          onClick={() =>
                                            setToggleSpeaker(false)
                                          }
                                        >
                                          <div
                                            className="color-green21"
                                            style={{
                                              position: "relative",
                                              left: "-0.35rem",
                                              top: "-0.1rem",
                                            }}
                                          >
                                            View Less
                                          </div>
                                          <div
                                            style={{
                                              cursor: "pointer",
                                              bottom: "0.5rem",
                                              left: "-0.35rem",
                                            }}
                                            className="arrowCollapse2"
                                          >
                                            <img
                                              style={{ width: "70%" }}
                                              src={arrow}
                                            />
                                          </div>
                                        </div>
                                      </td>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </>
                              );
                            })
                          )}
                        </tr>
                        {valueLogin?.role != "Startup" && 
                       (valueLogin?.role == "Mentor" ? valueLogin?.id == props?.modalData?.cohortAdminId ? true : false : valueLogin?.role == "Admin" ?  true : false) && (
                          <tr>
                            <td className="session-question">
                              <p>MENTORS INVITED</p>
                            </td>

                            {props?.modalData?.mentorUserList &&
                            props?.modalData?.mentorUserList?.length > 2 &&
                            !toggleMentor ? (
                              <div className="d-flex flex-column">
                                {props?.modalData?.mentorUserList.map(function (
                                  key,
                                  index
                                ) {
                                  if (index < 2)
                                    return (
                                      <>
                                        <td
                                          className="session-answer answersession2"
                                          // style={{ minWidth: "33rem" }}
                                        >
                                          <p className="sessionListMentor newuserTooltip"   onClick={() => {
                                  ViewProfile(
                                    key?.id,
                                    key?.applicant_name
                                  );
                                }}>{key.applicant_name}   <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    // top: "35px",
                                    width: "150px",
                                    position: "absolute",
                                    left: "50px",
                                    paddingBottom:"10px"
                                  }}
                                >
                                  View Mentor Profile
                                </span></p>
                                        </td>
                                        {props?.modalData?.mentorUserList
                                          ?.length > 1 && index == 1 ? (
                                          <td
                                            className="session-answer answersession2"
                                            // style={{ minWidth: "33rem" }}
                                          >
                                            <div
                                              className="d-flex"
                                              onClick={() =>
                                                setToggleMentor(true)
                                              }
                                            >
                                              <div
                                                className="color-green21"
                                                style={{
                                                  position: "relative",
                                                  left: "-0.35rem",
                                                  top: "-0.1rem",
                                                }}
                                              >
                                                View More
                                              </div>
                                              <div
                                                style={{
                                                  cursor: "pointer",
                                                  bottom: "0.5rem",
                                                  right: "1.25rem",
                                                }}
                                                className="arrowCollapse"
                                              >
                                                <img
                                                  style={{ width: "70%" }}
                                                  src={arrow}
                                                />
                                              </div>
                                            </div>
                                          </td>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    );
                                })}
                              </div>
                            ) : (
                              props?.modalData?.mentorUserList.map(function (
                                key,
                                index
                              ) {
                                return (
                                  <>
                                    <div className="d-flex flex-column">
                                      <td
                                        className="session-answer answersession2"
                                        // style={{ minWidth: "33rem" }}
                                      >
                                        <p className="sessionListMentor newuserTooltip"   onClick={() => {
                                  ViewProfile(
                                    key?.id,
                                    key?.applicant_name
                                  );
                                }}>{key.applicant_name}<span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  // top: "35px",
                                  width: "150px",
                                  position: "absolute",
                                  left: "50px",
                                  paddingBottom:"10px"
                                }}
                              >
                                View Mentor Profile
                              </span></p>
                                      </td>

                                      {index ===
                                        props?.modalData?.mentorUserList
                                          ?.length -
                                          1 &&
                                      props?.modalData?.mentorUserList?.length >
                                        2 ? (
                                        <td
                                          className="session-answer answersession2"
                                          // style={{ minWidth: "33rem" }}
                                        >
                                          <div
                                            className="d-flex"
                                            onClick={() =>
                                              setToggleMentor(false)
                                            }
                                          >
                                            <div
                                              className="color-green21"
                                              style={{
                                                position: "relative",
                                                left: "-0.35rem",
                                                top: "-0.1rem",
                                              }}
                                            >
                                              View Less
                                            </div>
                                            <div
                                              style={{
                                                cursor: "pointer",
                                                bottom: "0.5rem",
                                                left: "-0.35rem",
                                              }}
                                              className="arrowCollapse2"
                                            >
                                              <img
                                                style={{ width: "70%" }}
                                                src={arrow}
                                              />
                                            </div>
                                          </div>
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </>
                                );
                              })
                            )}
                          </tr>
                        )}
                        {valueLogin?.role != "Startup" && 
                       (valueLogin?.role == "Mentor" ? valueLogin?.id == props?.modalData?.cohortAdminId ? true : false : valueLogin?.role == "Admin" ?  true : false) && (
                          <tr>
                            <td className="session-question">
                              <p>STARTUPS INVITED</p>
                            </td>
                            {props?.modalData?.startUpUserList &&
                            props?.modalData?.startUpUserList?.length > 2 &&
                            !toggleStartup ? (
                              <div className="d-flex flex-column">
                                {props?.modalData?.startUpUserList.map(
                                  function (key, index) {
                                    if (index < 2)
                                      return (
                                        <>
                                          <td
                                            className="session-answer answersession2"
                                            // style={{ minWidth: "33rem" }}
                                          >
                                            <p className="sessionListMentor newuserTooltip"   onClick={() => {
                                 redirectProfile(key?.dippNumber);
                                }}>{key.applicant_name}
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    // top: "35px",
                                    width: "150px",
                                    position: "absolute",
                                    left: "50px",
                                    paddingBottom:"10px"
                                  }}
                                >
                                  View Startup Profile
                                </span></p>
                                          </td>
                                          {props?.modalData?.startUpUserList
                                            ?.length > 1 && index == 1 ? (
                                            <td
                                              className="session-answer answersession2"
                                              // style={{ minWidth: "33rem" }}
                                            >
                                              <div
                                                className="d-flex"
                                                onClick={() =>
                                                  setToggleStartup(true)
                                                }
                                              >
                                                <div
                                                  className="color-green21"
                                                  style={{
                                                    position: "relative",
                                                    left: "-0.35rem",
                                                    top: "-0.1rem",
                                                  }}
                                                >
                                                  View More
                                                </div>
                                                <div
                                                  style={{
                                                    cursor: "pointer",
                                                    bottom: "0.5rem",
                                                    right: "1.25rem",
                                                  }}
                                                  className="arrowCollapse"
                                                >
                                                  <img
                                                    style={{ width: "70%" }}
                                                    src={arrow}
                                                  />
                                                </div>
                                              </div>
                                            </td>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      );
                                  }
                                )}
                              </div>
                            ) : (
                              props?.modalData?.startUpUserList.map(function (
                                key,
                                index
                              ) {
                                return (
                                  <>
                                    <div className="d-flex flex-column">
                                      <td
                                        className="session-answer answersession2"
                                        // style={{ minWidth: "33rem" }}
                                      >
                                        <p className="sessionListMentor newuserTooltip"   onClick={() => {
                                redirectProfile(key?.dippNumber);
                                }}>{key.applicant_name}
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    // top: "35px",
                                    width: "150px",
                                    position: "absolute",
                                    left: "50px",
                                    paddingBottom:"10px"
                                  }}
                                >
                                  View Startup Profile
                                </span></p>
                                      </td>

                                      {index ===
                                        props?.modalData?.startUpUserList
                                          ?.length -
                                          1 &&
                                      props?.modalData?.startUpUserList
                                        ?.length > 2 ? (
                                        <td
                                          className="session-answer answersession2"
                                          // style={{ minWidth: "33rem" }}
                                        >
                                          <div
                                            className="d-flex"
                                            onClick={() =>
                                              setToggleStartup(false)
                                            }
                                          >
                                            <div
                                              className="color-green21"
                                              style={{
                                                position: "relative",
                                                left: "-0.35rem",
                                                top: "-0.1rem",
                                              }}
                                            >
                                              View Less
                                            </div>
                                            <div
                                              style={{
                                                cursor: "pointer",
                                                bottom: "0.5rem",
                                                left: "-0.35rem",
                                              }}
                                              className="arrowCollapse2"
                                            >
                                              <img
                                                style={{ width: "70%" }}
                                                src={arrow}
                                              />
                                            </div>
                                          </div>
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </>
                                );
                              })
                            )}
                          </tr>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                </table>
                {/* */}
              </div>
            </div>
          </Modal.Body>
                    
          <Modal.Footer className="d-flex justify-content-center">
            <div className="d-flex justify-between sessionFooterFix">
              {localStorage.getItem("SavedLoggedInData") &&
              valueLogin?.role !==
                "Admin" &&
                valueLogin?.role !==
                "Startup" &&
              (props?.modalData?.sessionStatus == "COMPLETED" ||
                !showEditSession) &&
              props?.fromModule !== undefined &&
              props?.fromModule !== "groupSessions" ? (
                <>
                  <div className="newuserTooltip top-btn">
                    <Button
                      onClick={handleClose}
                      text="CLOSE"
                      className="modalButton51 doc-upload"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        top: "65px",
                        left: "60px",
                        width: "150px",
                        height: "25px",
                      }}
                    >
                      Close window
                    </span>
                  </div>
                  {/* <div>
                <Button
                  onClick={handleDelete}
                  text="DELETE"
                  className="modalButton51 doc-uploadnext"
                ></Button>
              </div> */}
                </>
              ) : props?.fromModule !== undefined &&
                props?.fromModule !== "groupSessions" &&
                localStorage.getItem("SavedLoggedInData") &&
                props?.modalData?.sessionStatus === "SCHEDULED" &&
                valueLogin?.id ===
                  props?.modalData?.addedBy &&  testButtonsRow(props?.modalData) && valueLogin?.role !== "Admin" && valueLogin?.role !== "Startup" ? (
                <>
                  <div>
                    <Button
                      onClick={handleEdit}
                      text="EDIT"
                      className="modalButton51 doc-upload"
                    ></Button>
                  </div>
                  <div>
                    <Button
                      onClick={handleDelete}
                      text="DELETE"
                      className="modalButton51 doc-uploadnext"
                    ></Button>
                  </div>
                </>
              ) : props?.fromModule !== undefined &&
                props?.fromModule === "groupSessions" &&
                props?.modalData?.sessionStatus === "SCHEDULED" ?
                 (
                <>
                  {
                  //  testVCOpen2(props?.modalData)?
                  testButtonsRow(props?.modalData) && valueLogin?.role !== "Admin" &&   valueLogin?.role !== "Startup"  ?
                      // sessionMonth > moment(new Date()).format("MM") || sessionYear > moment(new Date()).format("YYYY") ? 
                      (
                        <>
                        <div>
                          <Button
                            onClick={handleEdit}
                            text="EDIT"
                            className="modalButton51 doc-upload"
                          ></Button>
                        </div>
                        <div>
                          <Button
                            onClick={handleDelete}
                            text="DELETE"
                            className="modalButton51 doc-uploadnext"
                          ></Button>
                        </div>
                      </>
                      ):
                  beforetime1 <
                  moment(new Date()).format("DD-MM-YYYY HH:mm A")  ?  (
                    <>
                      <div>
                        <Button
                          onClick={handleClose}
                          text="CLOSE"
                          className="modalButton51 doc-upload 7th"
                        ></Button>
                      </div>
                    </>
                  ) :
                
                   valueLogin?.role !== "Admin"
                    && 
                    testButtonsRow(props?.modalData)  
                    &&   valueLogin?.role !== "Startup"
                   ? 
                  (
                    <>
                      <div>
                        <Button
                          onClick={handleEdit}
                          text="EDIT"
                          className="modalButton51 doc-upload"
                        ></Button>
                      </div>
                      <div>
                        <Button
                          onClick={handleDelete}
                          text="DELETE"
                          className="modalButton51 doc-uploadnext"
                        ></Button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <Button
                          onClick={handleClose}
                          text="CLOSE"
                          className="modalButton51 doc-upload"
                        ></Button>
                      </div>
                    </>
                  )
                  }
                  {/* <div>
                    <Button
                      onClick={handleEdit}
                      text="EDIT"
                      className="modalButton51 doc-upload"
                    ></Button>
                  </div>
                  <div>
                    <Button
                      onClick={handleDelete}
                      text="DELETE"
                      className="modalButton51 doc-uploadnext"
                    ></Button>
                  </div> */}
                </>
              ) : (
                <div className="newuserTooltip top-btn">
                  <Button
                    onClick={handleClose}
                    text="CLOSE"
                    className="modalButton51 doc-upload"
                  ></Button>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{
                      top: "65px",
                      left: "50px",
                      width: "130px",
                      height: "25px",
                    }}
                  >
                    Close window
                  </span>
                </div>
              )}
              {/* {props.fromModule &&
              props.fromModule == "groupSessions" &&
              props?.modalData?.sessionStatus === "SCHEDULED" &&
              props?.fromPage &&
              props?.fromPage !== "invitationPage" ? (
                <>
                  <div>
                    <Button
                      onClick={handleEdit}
                      text="EDIT"
                      className="modalButton51 doc-upload"
                    ></Button>
                  </div>
                  <div>
                    <Button
                      onClick={handleDelete}
                      text="DELETE"
                      className="modalButton51 doc-uploadnext"
                    ></Button>
                  </div>
                </>
              ) : (
                ""
              )} */}
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, {
  deleteSessionData,
  deleteGroupSession,
})(withRouter(SessionsModal));
